import { render, staticRenderFns } from "./ModelBg.vue?vue&type=template&id=4929682a&scoped=true&"
import script from "./ModelBg.vue?vue&type=script&lang=js&"
export * from "./ModelBg.vue?vue&type=script&lang=js&"
import style0 from "./ModelBg.vue?vue&type=style&index=0&id=4929682a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4929682a",
  null
  
)

export default component.exports